//useUserStore  Запрос данных текущего пользователя
import { create } from 'zustand';
import { getUser } from 'services';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useUserStore = create(persist((set) => ({
	userData: {},
	isCallCenter: false,
	staffId: 0, // id сотрудника
	departmentId: 0, // департамент 
	userId: 0, // создатель записи
	isSuperAdmin: false, // суперадмин
	isSuperUser: false, // суперпользователь
	isOstrovok: false, // сотрудник ostrovok
	isOutstaffPers: false, // сотрудник outstaff персоналкин
	isOutstaffMsk: false, // сотрудник outstaff мск
	isOutstaff: false, // сотрудник outstaff
	getUser: async () => {
		const userData = await getUser();
		// console.log('userData', userData);
		const staffId = userData?.staff?.id;
		const userId = userData?.staff?.user;
		const departmentId = userData?.staff?.department;
		const isOstrovok = userData?.staff?.department === 8;
		const isOutstaffPers = userData?.staff?.department === 16;
		const isOutstaffMsk = userData?.staff?.department === 7;
		const isOutstaff = userData?.groups[0]?.name === 'outstaff';
		const isSuperAdmin = userData?.groups[0]?.name === 'megaadmin';
		const isSuperUser = userData?.is_superuser;
		const isCallCenter = userData?.groups[0]?.name === 'callcenter';

		set({ userData, staffId, isSuperAdmin, isOutstaff, isOstrovok, departmentId, userId, isCallCenter, isOutstaffPers, isOutstaffMsk, isSuperUser });
	},
}), { name: 'user', storage: createJSONStorage(() => localStorage), }));